import {Component, Inject, ViewChild} from '@angular/core';
import {LetterTemplateDataModel} from '../../../../models/letters/letter-template-data.model';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LettersService} from '../../../../services/letters.service';
import {ReportsService} from '../../../reports/reports.service';
import {ReportsLetterSubstituteModel} from '../../../reports/models/ReportsLetterSubstituteModel';

@Component({
    selector: 'app-letter-template-list',
    templateUrl: './letter-template-list.component.html',
    styleUrls: ['./letter-template-list.component.scss']
})
export class LetterTemplateListComponent {
    @ViewChild('letterTemplateListTable') letterTemplateListTable: TdoTableV2Component;
    searchPredicate: (data: any, filter: string) => boolean;

    isLoading: boolean = false;
    letterTemplateList: LetterTemplateDataModel[] = [];
    selectedLetterTemplate: LetterTemplateDataModel;
    ReportID: string;
    LOCID: string;
    OriginalLetterSubstituteID: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private snackBar: MatSnackBar,
                private lettersService: LettersService,
                private ReportService: ReportsService,
                private dialogRef: MatDialogRef<LetterTemplateListComponent>) {
        this.searchPredicate = (dataSearch: any, filter: string) => {
            if ((!dataSearch.model.LetterName ? '' : dataSearch.model.LetterName).toLowerCase().includes(filter)) {
                return true;
            } else {
                return false;
            }
        };

    }

    ngOnInit(): void {
        if (this.data) {
            this.LOCID = this.data.LOCID;
            this.ReportID = this.data.ReportID;
            this.OriginalLetterSubstituteID = this.data.LetterSubstituteID;
            this.letterTemplateList = this.data.letterTemplateList;
            this.letterTemplateListTable.updateData(this.letterTemplateList);
        }
    }


    onRowSelected(event: TdoTableSelectionEvent) {
        this.selectedLetterTemplate = event.model;
    }

    close() {
        this.dialogRef.close(false);
    }

    onOkAction() {
        if (this.selectedLetterTemplate === null || this.selectedLetterTemplate === undefined) {
            this.snackBar.open('Please select Letter Template', 'Letter', {
                duration: 3000,
                verticalPosition: 'top'
            });
            return;
        }

        const LetterSubstitute = new ReportsLetterSubstituteModel();
        LetterSubstitute.LetterSubstitueID = this.OriginalLetterSubstituteID;
        LetterSubstitute.LetterTemplateID = this.selectedLetterTemplate.LetterTamplateID;
        LetterSubstitute.LOCID = this.LOCID;
        LetterSubstitute.ReportID = this.ReportID;

        this.ReportService.SaveLetterSubstitutions(LetterSubstitute).subscribe(response => {
            if (response) {
                this.selectedLetterTemplate.LetterSubstitueID = response.LetterSubstitueID;
                this.showMessage('Success', 'Report Letter Substitute created!');
                this.dialogRef.close(this.selectedLetterTemplate);

            }
        }, err => {
            this.showMessage('Error', 'Error saving Letter Substitute');
            this.dialogRef.close(this.selectedLetterTemplate);
                

        });

       

    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

}
